import * as ACTIONS from '../actions/navParser';
import Utils from '../utils/Utils';

const initialState = {
  playAndGoNodes: {},
};

export default function playAndGo(state = initialState, action) {
  switch (action.type) {
    case ACTIONS.SET_PLAY_AND_GO_NODES:
      const node = action.node;
      let playAndGoNodes = Utils.buildFoxesNodes(node);
      if (state.playAndGoNodes)
        playAndGoNodes = Object.assign(state.playAndGoNodes, playAndGoNodes);
      return Object.assign({}, state, { playAndGoNodes });

    default:
      return state;
  }
}
